import { Spacer } from '@porsche-code/kado-ui';
import { PHeading } from '@porsche-design-system/components-react';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import { PersonSelect, RouteGuard } from '@/components';
import { NAMESPACES } from '@/config/i18n';

import { usePersonIdParam } from './person-info/-hooks';

export const Route = createFileRoute('/admin/person-info')({
  component: () => (
    <RouteGuard can="read" a="PersonInfo">
      <PersonInfo />
    </RouteGuard>
  ),
  beforeLoad: () => {
    return {
      breadcrumb: () => <Trans i18nKey="admin.personInfo.headline" />,
    };
  },
});

function PersonInfo() {
  const { t } = useTranslation(NAMESPACES);
  const navigate = useNavigate();

  const personId = Number(usePersonIdParam());

  return (
    <>
      <PHeading size="lg" aria-level={1} tag="h1">
        {t('admin.personInfo.headline')}
      </PHeading>
      <Spacer mb="md" />
      <PersonSelect
        name="person"
        label={t('common:person')}
        {...(!Number.isNaN(personId) && { value: personId })}
        dataFilter={{ pseudonymized: { _ne: false } }}
        groupBy={(opt) =>
          opt.deletedAt ? t('common:inactive') : t('common:active')
        }
        required
        onChange={(event) => {
          const id = (event.target as HTMLElement & { value: string })?.value;
          navigate({
            to: id ? `/admin/person-info/${id}/account` : '/admin/person-info',
          });
        }}
      />
      <Spacer mb="lg" />
      <Outlet />
    </>
  );
}
